/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Group_Language_LabelInputs */

const en_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Language`)
};

const fr_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue du groupe`)
};

const de_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppensprache`)
};

const it_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua di gruppo`)
};

const ru_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Групповой язык`)
};

const es_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma grupal`)
};

const zh_cn2_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`群体语言`)
};

const ja_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ言語`)
};

const hi_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह भाषा`)
};

const pt_pt2_plain_text_import_group_language_label = /** @type {(inputs: Plain_Text_Import_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Idiomas`)
};

/**
* | output |
* | --- |
* | "Group Language" |
*
* @param {Plain_Text_Import_Group_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_group_language_label = /** @type {((inputs?: Plain_Text_Import_Group_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Group_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_group_language_label(inputs)
	if (locale === "de") return de_plain_text_import_group_language_label(inputs)
	if (locale === "it") return it_plain_text_import_group_language_label(inputs)
	if (locale === "ru") return ru_plain_text_import_group_language_label(inputs)
	if (locale === "es") return es_plain_text_import_group_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_group_language_label(inputs)
	if (locale === "ja") return ja_plain_text_import_group_language_label(inputs)
	if (locale === "hi") return hi_plain_text_import_group_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_group_language_label(inputs)
	return en_plain_text_import_group_language_label(inputs)
});